import { useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useLeaveSurveyModal } from 'shared/hooks';
import { isLocalhost } from 'shared/utils';

const useRedirect = () => {
  const history = useHistory();
  const { uuid: plUuid } = useParams();
  const { disableSurvey } = useLeaveSurveyModal();

  /**
   * @param {string} location - redirect to location
   **/
  const redirectToLocation = useCallback(
    async (location, disableLeaveSurvey = false) => {
      if (disableLeaveSurvey) await disableSurvey();
      setTimeout(() => {
        window.location.href = location;
      });
    },
    [disableSurvey]
  );

  const redirectToDashboard = useCallback(
    (disableLeaveSurvey = true) => {
      if (isLocalhost()) history.push('/applications/start');
      else redirectToLocation(process.env.REACT_APP_DASHBOARD_PATH, disableLeaveSurvey);
    },
    [history, redirectToLocation]
  );

  const redirectToTimeout = useCallback(() => history.replace(`/applications/${plUuid}/review-app/timeout`), [plUuid, history]);

  return {
    redirectToDashboard,
    redirectToLocation,
    redirectToTimeout,
  };
};

export default useRedirect;
